import { FIXTURE_STATUS } from '@/constants/fixture';

export const useFixtureStatus = (status) => {
    let isInProgress = false;
    let isFinished = false;
    let isUpcoming = false;
    let isPaused = false;

    switch (status) {
        case FIXTURE_STATUS.FIRST_HALF:
        case FIXTURE_STATUS.HALF_TIME:
        case FIXTURE_STATUS.SECOND_HALF:
        case FIXTURE_STATUS.EXTRA_TIME:
        case FIXTURE_STATUS.BREAK_TIME:
        case FIXTURE_STATUS.WALKOVER:
        case FIXTURE_STATUS.PENALTIES:
        case FIXTURE_STATUS.LIVE:
            isInProgress = true;
            break;
        case FIXTURE_STATUS.TO_BE_DEFINED:
        case FIXTURE_STATUS.NOT_STARTED:
            isUpcoming = true;
            break;
        case FIXTURE_STATUS.MATCH_SUSPENDED:
        case FIXTURE_STATUS.MATCH_INTERRUPTED:
        case FIXTURE_STATUS.MATCH_CANCELED:
        case FIXTURE_STATUS.MATCH_POSTPONED:
            isPaused = true;
            break;
        case FIXTURE_STATUS.MATCH_FINISHED:
        case FIXTURE_STATUS.MATCH_FINISHED_AFTER_EXTRA_TIME:
        case FIXTURE_STATUS.MATCH_FINISHED_AFTER_PENALTIES:
        case FIXTURE_STATUS.MATCH_ABANDONED:
        case FIXTURE_STATUS.TECHNICAL_LOSS:
        default:
            isFinished = true;
            break;
    }

    return { isInProgress, isFinished, isUpcoming, isPaused };
};
